import { Filter } from "../../components/Filter/Filter";
import { useContext } from "react";
import { InvoiceContext } from "../../providers/InvoiceProvider";

export type AllowableFields = "status" | "startDate" | "endDate" | "customer";

export interface PaymentFilterProps {
  title?: string;
  clearFilterText?: string; // Custom text for the clear filter button
  btnText?: string; // Custom text for the apply filter button
  FilterFieldsLabel?: {
    [key in AllowableFields]?: string; // Custom labels for filter fields
  };
  allowableFields?: AllowableFields[];
}

const InvoiceFilter = ({
  title = "Invoices",
  clearFilterText = "Clear all Filter",
  btnText = "Apply Filter",
  FilterFieldsLabel = {
    status: "Select Status",
    startDate: "Invoice Start Date",
    endDate: "Invoice End Date",
    customer: "Search Customer",
  },
  allowableFields = ["status", "startDate", "endDate", "customer"],
}: PaymentFilterProps) => {
  const { handleApplyFilter, handleClearFilter, customerOptions } =
    useContext(InvoiceContext);
  const fieldsToUse: AllowableFields[] = allowableFields;

  return (
    <>
      <Filter
        label={title}
        clearFilterText={clearFilterText}
        allowableFields={fieldsToUse}
        btnText={btnText}
        FilterFieldsLabel={FilterFieldsLabel}
        onApplyFilter={handleApplyFilter}
        statusList={customerOptions}
        onClearFilter={handleClearFilter}
      />
    </>
  );
};

export default InvoiceFilter;
